import VerificationPending from "shared/dist/assets/images/VerificationPending.png";
import VerificationFailed from "shared/dist/assets/images/VerificationFailed.png";
import VerificationApproved from "shared/dist/assets/images/VerificationApproved.png";

const readyToLaunch = {
    title: "Ready to Launch",
    description:
        "The final launch will require you to be logged into your Metamask with some ETH available to activate the service. Only the owner of the organization can launch the service. Once you launch the service, it will take sometime for your changes to be reflected on AI Marketplace.",
    image: VerificationApproved,
};

const unableToPublishBuildInProgress = {
    title: "Unable to Publish the Service",
    description: "Component build is in Progress... please check back after sometime",
    image: VerificationPending,
};

const unableToPublishProtoInProgress = {
    title: "Unable to Publish the Service",
    description: "Proto compilation is in progress... please check back after sometime",
    image: VerificationPending,
};

const publishInProgress = {
    title: "Unable to Publish the Service",
    description: "Publishing in progress... please check back after sometime",
    image: VerificationPending,
};

const unableToPublish = {
    title: "Unable to Publish the Service",
    description:
        "We were unable to publish the service. Please check all the appropriate fields are filled and try publishing again.",
    image: VerificationFailed,
};

const alreadyPublished = {
    title: "The service is already Published",
    description: "",
    image: VerificationApproved,
};

export const bannerStates = {
    unableToPublish,
    unableToPublishProtoInProgress,
    unableToPublishBuildInProgress,
    publishInProgress,
    alreadyPublished,
    readyToLaunch,
};
